import { useThemeData } from '@msrceng/theme';
// Exports
// -------
export const activityTypeIconWidth = 42;
/**
 * Hooks that provides the baseline style customizations used by our TimelineItems to modify the
 * Fluent UI `ActivityItem` component.
 *
 * These are intentionally not applied to all `ActivityItem` (via `Customizer` and `scopedSettings`).
 * So these styles will need to be imported and applied directly:
 * ```jsx
 *   const activityItemStyles = useActivityItemStyles();
 *
 *   <ActivityItem styles={ activityItemStyles } />
 * ```
 */
export const useActivityItemStyles = () => {
    const { theme } = useThemeData();
    return {
        activityContent: {
            boxSizing: 'border-box',
            // This seems necessary to keep the width consistent when `overflow-wrap: break-word`
            // is necessary on children
            minWidth: '1%',
            width: '100%',
        },
        activityTypeIcon: {
            height: 'auto',
            textAlign: 'center',
            minWidth: activityTypeIconWidth,
        },
        personaContainer: {
            justifyContent: 'center',
            width: activityTypeIconWidth,
        },
        root: {
            color: theme.palette.neutralPrimaryAlt,
        },
        timeStamp: {
            color: theme.palette.neutralPrimaryAlt,
        },
    };
};
